export { WavelengthCreator } from './wavelength.creator';
export { WAVELENGTH_DEFAULTS, type WavelengthParams } from './wavelength.model';
